import { useEffect, useRef } from "react";
import { Box, Spinner, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router";
import CDS from "design-system";

import AppPage from "layouts/AppPage";
import { PEOPLE_TEAM_ROUTES } from "definitions/constants/routeConstants";
import { generatePath } from "helpers/url";
import { useCreateCustomForm } from "../hooks";

// No classic create form — spin up a draft and drop the user into the autosaved inline editor.
export default function CustomFormNewPage() {
  const navigate = useNavigate();
  const toast = useToast();
  const { mutate: createForm } = useCreateCustomForm();
  const kickedOff = useRef(false);

  useEffect(() => {
    if (kickedOff.current) return;
    kickedOff.current = true;

    createForm(
      { customForm: { name: "Untitled form", description: null } },
      {
        onSuccess: (form) => {
          navigate(
            generatePath({ path: PEOPLE_TEAM_ROUTES.customForms.show, params: { id: String(form.id) } }),
            { replace: true },
          );
        },
        onError: () => {
          toast({ title: "Couldn't create form", status: "error" });
          navigate(PEOPLE_TEAM_ROUTES.customForms.index);
        },
      },
    );
  }, [createForm, navigate, toast]);

  return (
    <AppPage>
      <Box p={12} display="flex" justifyContent="center" alignItems="center" flexDirection="column" gap={4}>
        <Spinner />
        <CDS.Text14 color="fg.subtle">Setting up your form…</CDS.Text14>
      </Box>
    </AppPage>
  );
}
